import App from '../../../../vendor_core/core/src/App';
import BetModel from '../../../../vendor_core/core/src/model/BetModel';
import GameModel from '../../../../vendor_core/core/src/model/GameModel';
import SpinModel from '../../../../vendor_core/core/src/model/SpinModel';
import ILoginData from '../../../../vendor_core/src/server/data/ILoginData';
import LoginDataParser from '../../../../vendor_core/src/server/parsers/LoginDataParser'
export default class CCLoginDataParser extends LoginDataParser {
    // For Coin Crush game remove only freespinSelectScreen paring !!!!
    parse(data: ILoginData): any[] {
        // data.refresh.symbols.push(data.refresh.bonusReel);
        let restoreData;
        if (data.refresh) {
            if (data.refresh.restoreState === undefined && data.refresh?.jackpotPickerResults) {
                GameModel.restoreData = this.jackpotRestoreTest;
            } else {
                GameModel.restoreData = data.refresh.restoreState;
            }
            restoreData = this.parseRestoreData(GameModel.restoreData);
            if (restoreData?.featureMode != undefined) {
                SpinModel.featureMode = restoreData.featureMode;
            } else {
                SpinModel.featureMode = -1;
            }
        }
        let creditsPerBet = Array.isArray(data.config.creditsPerBet)
                ? data.config.creditsPerBet[0]
                : data.config.creditsPerBet
        BetModel.betDivisor = creditsPerBet || 1;

        let legalBets = data.limits.legalBets;
        if (App.config.legalBetsHaveToBeModified) {
            legalBets = legalBets.map(bet => bet * creditsPerBet);
        }

        const result = {
            balance: data.stats.b,
            currency: data.stats.currency,
            sessionID: data.sid,
            serverGameConfig: this.parseGameConf(data),
            country: data.country,
            denomination: data.betMultiplier,
            coinSize: data.limits.defaultBet,
            coinSizeIndex: legalBets.indexOf(
                data.limits.defaultBet
            ),
            creditValues: legalBets,
            betMultiplier: data.betMultiplier || 1,
            restoreVersion: restoreData ? restoreData?.restoreVersion + 1 : 1,
            restoreData,
            betMultipliers: this.parseBetMultipliers(legalBets),
            betMultiplierMin: legalBets[0] / data.limits.defaultBet,
            betMultiplierMax:
                legalBets[legalBets.length - 1] /
                data.limits.defaultBet,
            numLines: 1,
        };

        return [result];
    }
}
